import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const offices = [
    {
      country: t.footer.countries.lithuania,
      company: '0g Baltics UAB',
      address: 'A. Goštauto g. 8-358',
      postal: 'LT-01108 Vilnius'
    },
    {
      country: t.footer.countries.latvia,
      company: '0g Baltics SIA',
      address: 'Elizabetes iela 31-8',
      postal: 'LV-1010 Riga'
    },
    {
      country: t.footer.countries.estonia,
      company: 'E2 Technologies OÜ',
      address: 'Lõõtsa tn 5',
      postal: '11415 Tallinn'
    }
  ];

  return (
    <footer className="py-16" style={{ backgroundColor: '#2D4A8F' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {offices.map((office) => (
            <div key={office.country} className="space-y-3">
              <h3 className="text-xl font-bold text-white mb-4">{office.country}</h3>
              <p className="text-gray-200 font-semibold">{office.company}</p>
              <div className="flex items-start space-x-2 text-gray-300">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <div>
                  <p>{office.address}</p>
                  <p>{office.postal}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-blue-400 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-gray-300">
              <Mail size={18} />
              <a href="mailto:info@0gbaltics.com" className="hover:text-white transition-colors">
                info@0gbaltics.com
              </a>
            </div>
            <p className="text-gray-300 text-sm">
              &copy; {new Date().getFullYear()} 0g Baltics. {t.footer.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;